import * as angular from 'angular';

import { ModalType } from '@mode/shared/ui-angularjs';

export class ConnectionAutoRefreshToggleController {
  private checked: boolean;
  private confirmButtonConfirm = 'Turn it off';
  private confirmButtonCancel = 'Cancel';
  private confirmContent = `
    <h1>Turn off automatic refresh for this schema?</h1>
    <p>
      Mode automatically runs a refresh query in the background daily
      in order to keep your database tables and definitions up to date.

      You are choosing to disable that feature. Do you want to continue?
    </p>
  `;
  private label = 'Automatically refresh the schema for this database';
  private inputName = 'data_source[auto_refresh]';

  isChecked(): boolean {
    return this.checked;
  }
}

export const ConnectionAutoRefreshToggleComponent: angular.IComponentOptions = {
  controller: ConnectionAutoRefreshToggleController,
  controllerAs: 'ctrl',
  bindings: {
    checked: '<',
  },
  template: `
    <form-toggle-confirm
      checked="ctrl.isChecked()"
      uncheck-confirm-content="ctrl.confirmContent"
      uncheck-confirm-button-confirm="{{ctrl.confirmButtonConfirm}}"
      uncheck-confirm-button-cancel="{{ctrl.confirmButtonCancel}}"
      confirm-on-uncheck="true"
      input-name="{{ctrl.inputName}}"
      label="{{ctrl.label}}"
      modal-type="${ModalType.Legacy}"
    />
  `,
};
